import Iconify from 'src/components/Iconify';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/@/components/ui/tabs';
import IdentificacaoSection from './realstate/IdentificacaoSection';
import PoliticasSection from './realstate/PoliticasSection';
import LocacaoVendaSection from './realstate/LocacaoVendaSection';
import FuncoesSection from './realstate/FuncoesSection';
import EscopoSection from './realstate/EscopoSection';
import PerguntasEssenciaisSection from './realstate/PerguntasEssenciaisSection';
import BuscaCatalogoSection from './realstate/BuscaCatalogoSection';

const SUB_TABS = [
    { value: 'identificacao', label: 'Identificação', icon: 'mdi:office-building-outline' },
    { value: 'politicas', label: 'Políticas', icon: 'mdi:file-document-outline' },
    { value: 'locacao-venda', label: 'Locação e Venda', icon: 'mdi:key-variant' },
    { value: 'funcoes', label: 'Funções', icon: 'mdi:cog-outline' },
    { value: 'escopo', label: 'Escopo de Atendimento', icon: 'mdi:filter-variant' },
    { value: 'busca-catalogo', label: 'Busca & Catálogo', icon: 'mdi:magnify' },
    { value: 'perguntas-essenciais', label: 'Perguntas Essenciais', icon: 'mdi:comment-question-outline' },
];

export default function RealstateModuleConfig({ aiAgent, changeModuleConfig }) {
    return (
        <Tabs defaultValue="identificacao" orientation="vertical" className="flex gap-6 items-start">
            <TabsList className="flex flex-col items-stretch h-auto w-[240px] bg-white rounded-xl border border-gray-100 p-2 gap-1 shrink-0">
                {SUB_TABS.map((tab) => (
                    <TabsTrigger
                        key={tab.value}
                        value={tab.value}
                        className="justify-start gap-2 px-3 py-2.5 rounded-lg text-sm text-gray-600 hover:bg-gray-50 data-[state=active]:bg-violet-50 data-[state=active]:text-[#7C3AED] data-[state=active]:shadow-none data-[state=active]:font-semibold w-full"
                    >
                        <Iconify icon={tab.icon} width={16} />
                        <span className="text-left flex-1 truncate">{tab.label}</span>
                    </TabsTrigger>
                ))}
            </TabsList>

            <div className="flex-1 min-w-0">
                <TabsContent value="identificacao" className="mt-0">
                    <IdentificacaoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="politicas" className="mt-0">
                    <PoliticasSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="locacao-venda" className="mt-0">
                    <LocacaoVendaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="funcoes" className="mt-0">
                    <FuncoesSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="escopo" className="mt-0">
                    <EscopoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="busca-catalogo" className="mt-0">
                    <BuscaCatalogoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="perguntas-essenciais" className="mt-0">
                    <PerguntasEssenciaisSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
            </div>
        </Tabs>
    );
}
